import React from 'react'
import { Link } from 'react-router-dom'
import Profile_Av from "../../../assets/images/lg/avatar1.jpg"

const Lockscreen = () => {
    return (
        <div className="row justify-content-center">
            <div className="p-4 col-md-5 auth-body border rounded">
                <form>
                    <ul className="row g-3 list-unstyled li_animate">
                        <li className="col-12 mb-3">
                            <div className="d-flex align-items-center">
                                <img className="rounded-4 img-thumbnail shadow avatar xl"
                                    src={Profile_Av} alt="Avatar" />
                                <div className="ms-3">
                                    <Link className="fs-4" to="/" title="">Michelle Hughes</Link>
                                    <p className="mb-0">michelle.hughes@gmail.com</p>
                                </div>
                            </div>
                        </li>
                        <li className="col-12">
                            <div className="mb-2">
                                <div className="form-label">Enter Password</div>
                                <input type="password" className="form-control form-control-lg"
                                    placeholder="***************" />
                            </div>
                        </li>
                        <li className="col-12 my-lg-4">
                            <Link className="btn btn-lg w-100 btn-primary text-uppercase mb-2" to="/"
                                title="">SIGN IN</Link>
                        </li>
                        <li className="col-12 text-center">
                            <span className="text-muted">
                                Don't have an account yet?
                                <Link to="/signup">Sign up here</Link>
                            </span>
                        </li>
                    </ul>
                </form>
            </div>
        </div>
    )
}

export default Lockscreen